
import { Component, Prop, Vue } from 'vue-property-decorator'
import CharField from '@/components/processing_steps/commons/fields/CharField.vue'
import SingleSelectField from "@/components/processing_steps/commons/fields/SingleSelectField.vue"
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import { IPSResultReport, IPSSelectOption } from '@/types/processingSteps'

@Component({
  components: {
    FormContainer,
    SingleSelectField,
    CharField
  }
})
export default class BaseInformationForm extends Vue {
  @Prop() resultReport!: IPSResultReport
  @Prop() availableProjects!: IPSSelectOption[]
  @Prop() formErrors!: { title?: string }
}
